export const focusFirstInvalidField = (fieldName) => {
  if (!fieldName || typeof document === 'undefined') return;
  const field = document.getElementById(fieldName)
    || document.querySelector(`[name="${fieldName}"]`);
  if (!field) return;
  if (typeof field.scrollIntoView === 'function') {
    field.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  if (typeof field.focus === 'function') {
    field.focus();
  }
};
